import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { makeStyles } from '@mui/styles'
import { SubTitle, Title } from '@/modules/base/components/texts'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'

const useStyles = makeStyles({
  dialog: {
    width: '400px',
  },
  dialogFixed: {
    height: '698px',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 40px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0',
    padding: '0 40px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 40px 30px',
    margin: '0',
  },
})

const ModalSmall = (props) => {
  const {
    title,
    subtitle,
    actions,
    type = 'dynamic',
    classes: classesExt = {},
    usePerfectScrollbar,
    dataQsId,
    ...otherProps
  } = props

  const classes = useStyles()

  const dialogContent = (
    <DialogContent classes={{ root: clsx(classes.content, classesExt.content) }}>
      { props.children }
    </DialogContent>
  )

  const content = usePerfectScrollbar ? <PerfectScrollbar children={dialogContent} /> : dialogContent

  return (
    <Dialog {...otherProps}
      scroll='paper'
      classes={{
        paper: classNames(
          classes.dialog,
          { [classes.dialogFixed]: type === 'fixed' },
        ),
        ...classesExt,
      }}
      data-qs-id={dataQsId}
    >
      <DialogTitle
        classes={{ root: classes.title }}
        disableTypography
      >
        {title && <Title className={classesExt.title}>{title}</Title>}
        {subtitle && <SubTitle className={classesExt.subtitle}>{subtitle}</SubTitle>}
      </DialogTitle>

      {content}

      <DialogActions classes={{ root: clsx(classes.actions, classesExt.actions) }}>
        { props.actions }
      </DialogActions>
    </Dialog>
  )
}

ModalSmall.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  actions: PropTypes.oneOfType(
    PropTypes.node,
    PropTypes.element,
  ),
  type: PropTypes.oneOf(['dynamic', 'fixed']),
  children: PropTypes.oneOfType(
    PropTypes.node,
    PropTypes.element,
  ),
  onClose: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
  classes: PropTypes.object,
}

export default ModalSmall
